import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function FeatureGrid() {
  const featured = articles.filter(a => a.isHot).slice(0, 4);

  return (
    <section className="bg-background-100 py-14 md:py-20 px-4 md:px-6">
      <div className="mx-auto max-w-7xl">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 leading-tight">
            今日<span className="text-accent-600">重磅</span>爆料
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            精选最火爆的爆料内容，让你一网打尽娱乐圈和网红圈的最新大瓜
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {featured[0] && (
            <Link
              to={`/article/${featured[0].slug}`}
              className="md:col-span-2 md:row-span-2 relative group rounded-xl overflow-hidden cursor-pointer h-[320px] md:h-[480px]"
            >
              <img
                src={featured[0].coverImage}
                alt={featured[0].title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-block px-3 py-1 rounded-full bg-primary-500/90 text-white text-xs font-medium mb-3">
                  {featured[0].isVideo ? '视频' : '热门爆料'}
                </span>
                <h3 className="text-lg md:text-xl font-bold font-heading text-white leading-snug mb-2">
                  {featured[0].title}
                </h3>
                <p className="text-sm text-white/70 line-clamp-2">{featured[0].excerpt}</p>
                <div className="flex items-center gap-3 mt-3 text-xs text-white/60">
                  <span>{featured[0].publishDate}</span>
                  <span><i className="ri-eye-line mr-1"></i>{(featured[0].viewCount / 10000).toFixed(1)}万</span>
                  <span><i className="ri-chat-3-line mr-1"></i>{featured[0].commentCount}</span>
                </div>
              </div>
            </Link>
          )}

          {featured.slice(1, 4).map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group rounded-xl overflow-hidden cursor-pointer bg-background-50 flex flex-col"
            >
              <div className="relative h-40 md:h-48 overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-primary-500/90 text-white text-xs font-medium">
                    <i className="ri-fire-line text-[10px]"></i>
                    热
                  </span>
                </div>
              </div>
              <div className="flex-1 p-4 flex flex-col">
                <h3 className="text-sm md:text-base font-semibold font-heading text-foreground-900 leading-snug mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-600 line-clamp-1 mb-3">{article.excerpt}</p>
                <div className="mt-auto flex items-center gap-3 text-xs text-foreground-500">
                  <span>{article.publishDate}</span>
                  <span><i className="ri-eye-line mr-0.5"></i>{(article.viewCount / 10000).toFixed(1)}万</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}